import { render, staticRenderFns } from "./board-agile-level-setting.vue?vue&type=template&id=62ce6b20&scoped=true&"
import script from "./board-agile-level-setting.vue?vue&type=script&lang=js&"
export * from "./board-agile-level-setting.vue?vue&type=script&lang=js&"
import style0 from "./board-agile-level-setting.vue?vue&type=style&index=0&id=62ce6b20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ce6b20",
  null
  
)

export default component.exports